import { globalPut } from '../index';

export const markAsPaid = (data) => {
  return globalPut(`/affiliation/mark-as-paid`, data);
};
